const PageTag = ({tagText}) => {
    return (
        <div className = "page-tag">{tagText}</div>
    )
};

export default PageTag;